module.exports = __webpack_public_path__ + "content/dam/oppo/coloros/media/05-02.dd986cb2.mp3";